<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <div id="app" class="my-0 py-0">
            <v-app id="inspire">
                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                    <v-card v-model="show" class="py-0">
                        <v-toolbar class="py-0 my-0" dark color="purple">
                            <v-toolbar-title class="my-0 py-0">Registro de Capacitación (EI 089)</v-toolbar-title>
                            <v-spacer></v-spacer>
                            Código: {{ codgral }}
                            <v-spacer></v-spacer>
                            <div>
                                <v-btn icon @click="show = false">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </div>
                        </v-toolbar>
                    </v-card>
                    <v-card color="purple lighten-4">
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="12" sm="4" md="1">
                                    Año: {{ periodo }}
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card color="blue lighten-5" tile>
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="12" sm="12" md="8">
                                    <!-- <v-card-actions> -->
                                    <v-row dense>
                                        <v-col cols="12" sm="12" md="12">
                                            Tema desarrollado:
                                            <p>{{ tema }}</p>
                                        </v-col>
                                    </v-row>
                                    <v-row dense>
                                        <v-col cols="12" sm="12" md="12">
                                            Objetivo:
                                            <p>{{ objetivo }}</p>
                                        </v-col>
                                    </v-row>
                                    <v-row dense>
                                        <v-col cols="12" sm="12" md="8">
                                            Capacitador: {{ capacitador }}
                                        </v-col>
                                    </v-row>
                                    <!-- </v-card-actions> -->
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                    <!-- <h6><b> Tipo de Evaluación </b></h6>
                            <hr> -->
                                    <div class="d-flex" style="max-width:600px">
                                        <h6><b> Tipo de Evaluación: </b></h6>
                                    </div>
                                    <div class="d-flex" style="max-width:600px">
                                        <v-checkbox v-model="tipoaulica" value="ON" label="Áulica"></v-checkbox>
                                        <v-checkbox v-model="tipodesemp" value="ON" label="Desempeño"></v-checkbox>
                                        <v-checkbox v-model="tipootro" value="ON" label="Otros  "></v-checkbox>
                                    </div>
                                    <div class="d-flex" style="max-width:600px">
                                        {{ evalotro }}
                                    </div>
                                    <div class="d-flex" style="max-width:600px">
                                        <h6><b> Lugar de Capacitación: </b></h6>
                                    </div>
                                    <div class="d-flex" style="max-width:600px">
                                        <v-radio-group v-model="lugar" row dense>
                                            <v-radio label="Planta / Oficina" value="PO"></v-radio>
                                            <v-radio label="Obras" value="OB"></v-radio>
                                            <v-radio label="Sucursal Bs As" value="SU"></v-radio>
                                            <v-radio label="Otros" value="OT"></v-radio>
                                        </v-radio-group>
                                    </div>
                                    <div class="d-flex" style="max-width:600px">
                                        {{ lugarotro }}
                                    </div>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card color="purple lighten-4" tile>
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="12" sm="6" md="3">
                                    Fecha: {{ fecha }}
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    Horas impartidas: {{ horas }}
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    Desde: {{ desde }}
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    Hasta: {{ hasta }}
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="6" md="6">
                                    Objetivo N°: {{ numobj }}
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card color="purple lighten-3" tile>
                        <v-card-text>

                            <v-row dense>
                                <v-col cols="12" sm="12" md="12">
                                    <v-data-table :headers="headers" :items="participantes" :items-per-page="100"
                                        hide-default-footer class="elevation-1">
                                    </v-data-table>
                                </v-col>
                            </v-row>

                            <v-row dense>
                                <v-col cols="12" sm="12" md="12">
                                    <v-data-table :headers="headersC" :items="listadocurso" :items-per-page="100"
                                        hide-default-footer class="elevation-1">

                                    </v-data-table>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                </v-form>
            </v-app>
        </div>
    </v-dialog>
</template>

<style lang="scss">
.v-input--radio-group__input {
    label {
        margin: 0 !important;
    }
}

.v-label {
    margin: 0 !important;
}

.v-input--selection-controls__input {
    label {
        margin: 0 !important;
    }
}
</style>
<style scoped>
.font-class-name {
    font-size: 14px;
}

.educacion {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
}

.educacion__niveles {
    border: solid 1px;
    list-style: none;
}
</style>
<script>
import moment from "moment";
import axios from "../../../../src/axios-auth";
export default {
    data: (vm) => ({
        usuario: "",
        valid: false,
        lazy: false,
        requiredRules: [(v) => !!v || "Dato obligatorio"],
        fecha: "",
        legajo: "",
        nomlegajo: [],
        particotro: "",
        particdni: "",
        participantes: [],
        headers: [
            { text: "Nombre", value: "nombre", sortable: false },
            { text: "Legajo", value: "legajo", sortable: false },
            { text: "DNI", value: "dni", sortable: false },
            { text: "Borrar", value: "actions", sortable: false },
        ],
        headersC: [
            { text: "Código", value: "curso", sortable: false },
            { text: "Curso", value: "descr", sortable: false },
            { text: "Borrar", value: "actions", sortable: false },
        ],
        periodo: moment().year(),
        resp: "",
        tema: "",
        objetivo: "",
        capacitador: "",
        horas: "",
        numobj: "",
        tipoaulica: "",
        tipodesemp: "",
        tipootro: "",
        evalotro: "",
        desde: "",
        hasta: "",
        lugar: "",
        lugarotro: "",
        nombre: "",
        dni: "",
        leg: "",
        cursos: [],
        curso: "",
        listadocurso: [],
        deshabilitar: false,
        editedIndex: -1,
        dialogDelete: false,
        editedIndexC: -1,
        dialogDeleteC: false,
        datospartic: [],
        datoscurso: [],
    }),
    computed: {

        show: {
            get() {
                if (this.visible == true) {
                    this.cargarRegistro();
                }
                return this.visible;
            },

            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$refs.form.resetValidation();
                    document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },
    },
    props: ["codgral", "visible"],
    methods: {

        cargarRegistro() {
            let self = this;
            axios
                .get("/RRHH/CargarRegistro", {
                    params: {
                        codgral: self.codgral
                    },
                })
                .then((response) => {
                    self.periodo = response.data.periodo;
                    self.tema = response.data.tema;
                    self.objetivo = response.data.objetivo;
                    self.capacitador = response.data.capacitador;
                    self.tipoaulica = response.data.tipoaulica;
                    self.tipodesemp = response.data.tipodesemp;
                    self.tipootro = response.data.tipootro;
                    self.evalotro = response.data.evalotro;
                    self.lugar = response.data.lugar;
                    self.lugarotro = response.data.lugarotro;
                    self.numobj = response.data.numobj;
                    self.fecha = response.data.fecha;
                    self.desde = response.data.desde;
                    self.hasta = response.data.hasta;
                    self.horas = response.data.horas;
                    self.listadocurso = response.data.cursos;
                    self.participantes = response.data.participantes;

                })
                .catch((error) => {
                    console.log(error);
                });
        },

        vaciarModels() {
            this.fecha = "";
            this.periodo = "";
            this.tema = "";
            this.objetivo = "";
            this.tipoaulica = "";
            this.tipodesemp = "";
            this.tipootro = "";
            this.evalotro = "";
            this.lugar = "";
            this.lugarotro = "";
            this.desde = "";
            this.hasta = "";
            this.horas = "";
            this.capacitador = "";
            this.numobj = "";
            this.datoscurso = [];
            this.datospartic = [];
            this.deshabilitar = false;
            //this.$router.push({ name: "MainRRHH" });
        },
    },
};
</script>
